/* ---------- Acordeões ---------- */
document.querySelectorAll('[data-acc]').forEach(acc=>{
  acc.addEventListener('click',e=>{
    const btn=e.target.closest('.acc__btn'); if(!btn)return;
    btn.parentElement.classList.toggle('is-open');
  });
});

/* ---------- Drawer mobile ---------- */
(function(){
  const body=document.body,
        burger=document.getElementById('burger'),
        drawer=document.getElementById('drawer'),
        scrim=document.getElementById('scrim'),
        close=document.getElementById('drawerClose');
  if(!burger||!drawer||!scrim)return;
  let lastY=0;

  function open(){
    lastY=window.scrollY;
    scrim.hidden=false;
    // força um frame antes de animar, senão a transição não roda
    requestAnimationFrame(()=>body.classList.add('menu-open'));
    burger.setAttribute('aria-expanded','true');
    drawer.setAttribute('aria-hidden','false');
    // trava o scroll do fundo sem perder a posição
    body.style.position='fixed';
    body.style.top=`-${lastY}px`;
    body.style.width='100%';
    close.focus();
  }
  function shut(){
    body.classList.remove('menu-open');
    burger.setAttribute('aria-expanded','false');
    drawer.setAttribute('aria-hidden','true');
    body.style.position='';body.style.top='';body.style.width='';
    window.scrollTo(0,lastY);
    setTimeout(()=>{scrim.hidden=true},280);
  }
  burger.addEventListener('click',()=>body.classList.contains('menu-open')?shut():open());
  close.addEventListener('click',shut);
  scrim.addEventListener('click',shut);
  document.addEventListener('keydown',e=>{if(e.key==='Escape'&&body.classList.contains('menu-open'))shut()});
  drawer.querySelectorAll('a[href^="#"]').forEach(a=>{
    a.addEventListener('click',e=>{
      const target=document.querySelector(a.getAttribute('href'));
      e.preventDefault();
      shut();
      // espera destravar o scroll antes de navegar
      setTimeout(()=>target&&target.scrollIntoView({behavior:'smooth',block:'start'}),60);
    });
  });
})();

/* ---------- Link ativo na subnav (e auto-scroll do pill) ---------- */
(function(){
  const links=new Map([...document.querySelectorAll('.subnav__links a')]
    .map(a=>[a.getAttribute('href').slice(1),a]));
  const rail=document.querySelector('.subnav__links');
  if(!('IntersectionObserver' in window)||!rail)return;
  const io=new IntersectionObserver(entries=>{
    entries.forEach(en=>{
      if(!en.isIntersecting)return;
      const a=links.get(en.target.id); if(!a)return;
      links.forEach(l=>l.classList.remove('is-active'));
      a.classList.add('is-active');
      // mantém o pill ativo visível no rail horizontal
      const r=rail.getBoundingClientRect(), t=a.getBoundingClientRect();
      if(t.left<r.left||t.right>r.right){
        rail.scrollTo({left:a.offsetLeft-24,behavior:'smooth'});
      }
    });
  },{rootMargin:'-35% 0px -55% 0px'});
  document.querySelectorAll('section[id]').forEach(s=>io.observe(s));
})();

/* ---------- Play/pause do vídeo da cédula ---------- */
(function(){
  const btn=document.getElementById('vplay');
  const vid=document.querySelector('.stage__frame video');
  if(!btn||!vid)return;
  // respeita quem pediu menos animação no sistema
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches){
    vid.removeAttribute('autoplay'); vid.pause();
  }
  function sync(){
    const tocando=!vid.paused;
    btn.textContent=tocando?'❚❚':'▶';
    btn.setAttribute('aria-label',tocando?'Pausar vídeo':'Reproduzir vídeo');
    btn.setAttribute('aria-pressed',String(!tocando));
  }
  btn.addEventListener('click',()=>{vid.paused?vid.play():vid.pause()});
  vid.addEventListener('play',sync); vid.addEventListener('pause',sync);
  sync();
  // só carrega/roda quando estiver visível — poupa dados no celular
  if('IntersectionObserver' in window){
    new IntersectionObserver(([e])=>{
      if(e.isIntersecting){ if(vid.dataset.userPaused!=='1') vid.play().catch(()=>{}); }
      else vid.pause();
    },{threshold:.25}).observe(vid);
    btn.addEventListener('click',()=>{vid.dataset.userPaused=vid.paused?'1':'0'});
  }
})();

/* ---------- Order bump ---------- */
(function(){
  const box=document.querySelector('.bump'),inp=box&&box.querySelector('input');
  if(!inp)return;
  inp.addEventListener('change',()=>{box.style.background=inp.checked?'#F6EDCE':''});
})();

/* ---------- Barra fixa: do fim do hero até o rodapé ---------- */
(function(){
  const bar=document.querySelector('.stickybuy'),
        hero=document.querySelector('.hero'),
        rodape=document.querySelector('.footer');
  if(!bar||!hero||!('IntersectionObserver' in window))return;
  let passouHero=false, noRodape=false;
  const sync=()=>bar.classList.toggle('is-on', passouHero && !noRodape);
  new IntersectionObserver(([e])=>{passouHero=!e.isIntersecting;sync();},{threshold:0}).observe(hero);
  if(rodape) new IntersectionObserver(([e])=>{noRodape=e.isIntersecting;sync();},{threshold:0}).observe(rodape);
})();

/* ---------- Carrosséis: setas, bolinhas e borda esmaecida ---------- */
(function(){
  document.querySelectorAll('[data-carousel]').forEach(c=>{
    const rail=c.querySelector('.rail');
    const itens=[...rail.children];
    if(!itens.length) return;

    // bolinhas
    const dots=document.createElement('div');
    dots.className='dots';
    itens.forEach((_,i)=>{
      const b=document.createElement('button');
      b.type='button';
      b.setAttribute('aria-label','Ir para o item '+(i+1)+' de '+itens.length);
      b.addEventListener('click',()=>itens[i].scrollIntoView({behavior:'smooth',block:'nearest',inline:'start'}));
      dots.appendChild(b);
    });
    c.insertAdjacentElement('afterend',dots);

    function passo(){
      const card=itens[0];
      return card ? card.getBoundingClientRect().width+24 : rail.clientWidth*.8;
    }
    c.querySelectorAll('.carousel__nav').forEach(btn=>{
      btn.addEventListener('click',()=>rail.scrollBy({left:passo()*(+btn.dataset.dir),behavior:'smooth'}));
    });

    function sync(){
      const fim = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth-4;
      const ini = rail.scrollLeft<=2;
      const prev=c.querySelector('.carousel__nav--prev'), next=c.querySelector('.carousel__nav--next');
      if(prev) prev.style.opacity = ini ? .35 : 1;
      if(next) next.style.opacity = fim ? .35 : 1;
      c.dataset.fim = fim ? '1' : '0';
      const atual = Math.round(rail.scrollLeft/passo());
      [...dots.children].forEach((b,i)=>b.setAttribute('aria-current', i===Math.min(atual,itens.length-1)));
    }
    rail.addEventListener('scroll',sync,{passive:true});
    window.addEventListener('resize',sync);
    sync();
  });
})();

/* ---------- Compra: três opções fixas, um toque ---------- */
(function(){
  const ITEM='C\u00e9dula Colecion\u00e1vel Bolsonaro';
  document.querySelectorAll('[data-comprar]').forEach(a=>{
    a.addEventListener('click',function(){
      const url=a.dataset.checkout, qtd=+a.dataset.qtd, valor=+a.dataset.valor;
      const payload={currency:'BRL',value:valor,
        items:[{item_name:ITEM,item_variant:a.dataset.nome,quantity:qtd,price:valor}]};
      window.dataLayer=window.dataLayer||[];
      window.dataLayer.push(Object.assign({event:'add_to_cart'},payload));
      window.dataLayer.push(Object.assign({event:'begin_checkout'},payload));
      
    });
  });
  window.dataLayer=window.dataLayer||[];
  window.dataLayer.push({event:'view_item',currency:'BRL',value:49.90,items:[{item_name:ITEM}]});
})();

/* ---------- WhatsApp: socorro, nunca canal de pedido ---------- */
(function(){
  const NUM='5541985105282';
  const TXT=encodeURIComponent('Olá, tenho uma dúvida sobre a cédula do Bolsonaro.');
  document.querySelectorAll('[data-wa]').forEach(a=>{
    const local=a.dataset.wa;
    a.href='https://wa.me/'+NUM+'?text='+TXT+'&utm_source=site&utm_medium=whatsapp&utm_content='+local;
    a.target='_blank'; a.rel='noopener';
    a.addEventListener('click',()=>{
      window.dataLayer=window.dataLayer||[];
      window.dataLayer.push({event:'contato_whatsapp',local:local});
    });
  });
})();
